<template>
  <div class="stockProduct_box">
      <Qrcode-Dialog :instockdia.sync="instockdia" :maincusCode="maincusCode"/>
      <dialogPlugin   :showProduct.sync='showProduct' :onlineItems="onlineItems"/>
      <!-- 查看产品的代理商 -->
	   <el-dialog
	     :title="$t('other.a2417')" 
	     :visible.sync="agentDialog"
	     width="30%"
	    >
        <div class="gidan">
            <el-table v-if="agentList" :data="agentList" border height="400px" >
                <el-table-column :label="$t('other.a2418')"   >
                    <template slot-scope="props">
                       <span>{{props.row.userName}}</span>
                    </template>
                </el-table-column>
               <el-table-column label="userId"  >
                    <template slot-scope="props">
                       <span>{{props.row.userId}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a2419')"   >
                    <template slot-scope="props">
                       <span>{{props.row.cusCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a2889')"  >
                    <template slot-scope="props">
                       <span>{{props.row.unShipped}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
	     <span slot="footer" class="dialog-footer">
	       <el-button type="primary" @click="agentDialog= false">{{$t('other.a5')}}</el-button>
	     </span>
	   </el-dialog>
  

      <el-dialog
		:title="$t('other.a1423')"
		:visible.sync="updatPic"
		width="30%"
		>
		<div style="text-align: center">
            <el-upload
            class="avatar-uploader"
            action="https://erp.shopsbu.com/service/access/upload"
            :show-file-list="false"
            :headers="token"
            :on-success="handleAvatarSuccess"
           >
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">{{$t('other.a281')}}</div>
            </el-upload>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="updatPic = false">{{$t('other.a106')}}</el-button>
			<el-button type="primary" @click="imgConfirm()">{{$t('other.a279')}}</el-button>
		</span>
		</el-dialog>
      	<!-- 录入产品条形码 -->
		
      <div class="check_Top">
        <div class="check_desc">
            <div class="ivmfjn">
                
          <div style="margin:15px 0;font-size:18px">{{$t('other.a1745')}}</div>
                
            </div>
            <el-button size="medium"  @click="goBack()"  type="primary"><i class="iconfont icon-fanhui-"></i> {{$t('other.a605')}}</el-button>
        </div>
      </div>
      
      <!-- 产品列表 -->
      <div  style="margin-top:30px;">
          <div class="header_tip">
              
          </div>
         <div class="basic_info">
            <div class="title">{{$t('other.a735')}}</div>
            <div class="basic_detail">
                <div class="itemskuImg" @click="changePic(ruleForm,0)">
                    <img :src="ruleForm.image ? ruleForm.image : ruleForm.storeItems[0].image " />
                </div>
                <div class="skuDesc">
                    {{$t('other.a179')}}：
                    <span v-if="!ruleForm.checkedName">{{ruleForm.groupName}}</span>
                    <el-input  style="width:650px" v-show="ruleForm.checkedName"  :placeholder="$t('other.a2531')"  v-model="ruleForm.groupName"> </el-input>
                    <!-- <i v-show="!ruleForm.checkedName" class="el-icon-edit" @click="ruleForm.checkedName=true"></i> -->
                    <el-button style="margin-left: 15px;" v-show="ruleForm.checkedName"  @click="updataItemSku()" size="mini" type="primary">{{$t('other.a145')}}</el-button>
                    <el-button style="margin-left: 15px;" v-show="ruleForm.checkedName"  @click="ruleForm.checkedName=false" size="mini" type="danger">{{$t('other.a146')}}</el-button>
                    
                </div>
                <div class="skuDesc">
                    {{$t('other.a735')}}：
                    <span v-show="!ruleForm.checked">{{ruleForm.itemSku}}</span>
                    
                    <el-input type="textarea" style="width:350px" v-show="ruleForm.checked" :rows="1" :placeholder="$t('other.a2531')"  v-model="ruleForm.itemSku"> </el-input>
                    <!-- <i v-show="!ruleForm.checked" class="el-icon-edit" @click="ruleForm.checked=true"></i> -->
                    <el-button style="margin-left: 15px;" v-show="ruleForm.checked"  @click="updataItemSku()" size="mini" type="primary">{{$t('other.a145')}}</el-button>
                    <el-button style="margin-left: 15px;" v-show="ruleForm.checked"  @click="ruleForm.checked=false" size="mini" type="danger">{{$t('other.a146')}}</el-button>
                </div>
            </div>
        </div>
        <div class="basic_info">
            <div class="title">
                <div>子sku（{{ruleForm.storeItems.length}}）</div>
                <!-- <div>
                    <el-switch
                    style="display: block"
                    v-model="value4"
                    active-color="#13ce66"
                    @change="turnOn()"
                    inactive-color="#ff4949"
                    active-text="固定毛利率"
                    inactive-text="固定供货价">
                    </el-switch>
                </div> -->

                
            </div>
            <div class="basic_detail">
                <el-form :model="ruleForm"  ref="ruleForm"  class="demo-ruleForm">
                     <el-form-item label="" prop="name">
                       <el-table
                            ref="multipleTable"
                            :data="ruleForm.storeItems"
                            :show-header="false"
                            @selection-change="handleSelectionChange"
                            border
                           > 
                           
                            <el-table-column width="100">
                                <template slot-scope="props" >
                                    <div class="pic_box" @click="changePic(props.row,1)">
                                        <img style="width:100%" :src="props.row.image" />
                                    </div>
							    </template>
                            </el-table-column>
                            <el-table-column>
                                <template slot-scope="props">
                                    <div style="font-size:14px;">
                                        {{$t('other.a2139')}}：
                                        <span v-show="!props.row.skuNameChecked">{{props.row.skuName ? props.row.skuName : $t('other.a260')}}</span>
                                        <el-input v-show="props.row.skuNameChecked" size="mini" style="width: 200px;;" v-model="props.row.skuName" :rows="1" type="textarea"  autosize="autosize" > </el-input>
                                        <div style="margin:5px 0" v-show="props.row.skuNameChecked">
                                             <el-button v-show="props.row.skuNameChecked" size="mini" type="primary" @click="saveClick(props.$index, props.row)">{{$t('other.a274')}}</el-button>
                                             <el-button v-show="props.row.skuNameChecked" size="mini" type="danger" @click="saveClick(props.$index, props.row)">{{$t('other.a106')}}</el-button>
                                        </div>
                                        <!-- <i  v-show="!props.row.skuNameChecked"  class="el-icon-edit" @click="editClick(props.$index, props.row)"></i> -->
                                    </div>
                                    <div style="font-size:14px;">
                                        skuName：
                                        <span v-show="!props.row.nameChecked">{{props.row.variationName ? props.row.variationName : $t('other.a260')}}</span>
                                        <el-input v-show="props.row.nameChecked" size="mini" style="width: 200px;;" v-model="props.row.variationName" :rows="1" type="textarea"  autosize="autosize" > </el-input>
                                        <div style="margin:5px 0" v-show="props.row.nameChecked">
                                             <el-button v-show="props.row.nameChecked" size="mini" type="primary" @click="saveClickvariationName(props.$index, props.row)">{{$t('other.a274')}}</el-button>
                                             <el-button v-show="props.row.nameChecked" size="mini" type="danger" @click="saveClickvariationName(props.$index, props.row)">{{$t('other.a106')}}</el-button>
                                        </div>
                                        <!-- <i  v-show="!props.row.nameChecked"  class="el-icon-edit" @click="editvaritionNmae(props.$index, props.row)"></i> -->
                                    </div>
                                    <div style="font-size:14px;">{{$t('other.a226')}}{{props.row.cusCode}}</div>
                                    
                                    
                                    
							    </template>
                            </el-table-column>
                            <el-table-column >
                                <template slot-scope="props">
                                    
                                    <div v-if="vipLevel == 0">
                                        {{$t('other.a2890')}} ：{{props.row.auditedStock}}
                                    </div>
                                    <div style="font-size:14px;" v-if="vipLevel == 1">{{$t('other.a1166')}}：{{props.row.storeId}}</div>
                                    <div style="font-size:14px;" v-if="vipLevel == 1">{{$t('other.a2545')}}：{{props.row.userName}}</div>
                                    <div>
                                        {{$t('other.a1171')}}
                                        <el-tooltip class="item" effect="dark" :content="$t('other.a1123')" placement="top-start">
                                            <i class="el-icon-question oook"></i>:
                                        </el-tooltip>
                                        ：{{props.row.storeNum}}
                                    </div>
                               
                                    <div style="display:flex;align-items: center"  >
                                        {{$t('other.a2546')}}
                                        <el-tooltip class="item" effect="dark" :content="$t('other.a2547')" placement="top-start">
                                            <i class="el-icon-question oook"></i>:
                                        </el-tooltip>
                                        ：
                                        <el-switch
                                            style="display: block"
                                            v-model="props.row.synchrony"
                                            active-color="#13ce66"
                                            inactive-color="#ff4949"
                                            @change="updateShopeeItem(props.row)"
                                            :active-text="$t('userStoreItems').on"
                                            :inactive-text="$t('userStoreItems').off">
                                            >
                                        </el-switch>
                                    </div>
                                    
							    </template>
                            </el-table-column>
                             <el-table-column>
                                <template slot-scope="props">
                                    <div>{{$t('other.a2153')}}：{{props.row.packageLength}} x {{props.row.packageLength}} x {{props.row.packageHeight}} cm</div>
                                    <div>{{$t('other.a1516')}}：{{props.row.weight}} kg</div>
                                    <div>
                                        {{$t('other.a219')}}：￥
                                         <span v-if="!props.row.checked02">{{props.row.price.toFixed(2)}}</span>
                                         <el-input style="width:100px" size="mini" v-if="props.row.checked02 " v-model="props.row.price"></el-input>
                                         <!-- <i class="el-icon-edit-outline" v-if="!props.row.checked02 " @click="upadataItemPrice(props.row)"></i> -->
                                         <el-button style="margin-left: 15px;" v-show="props.row.checked02"  @click="updataCostAndSupply(props.row)" size="mini" type="primary">{{$t('other.a145')}}</el-button>
                                         <el-button style="margin-left: 15px;" v-show="props.row.checked02"  @click="props.row.checked02=false" size="mini" type="danger">{{$t('other.a146')}}</el-button>
                                    </div>
                                 
                                    <div v-if="props.row.fixGrossProfitRate && value4">
                                         {{$t('other.a2891')}}：
                                         <span v-if="!props.row.checked">{{props.row.fixGrossProfitRate}}</span>
                                    </div>
							    </template>
                            </el-table-column>
                            <el-table-column v-if="vipLevel == 0">
                                <template slot-scope="props">
                                    <div class="btn"><el-button style="min-width:150px" size="mini" type="primary" @click="viewstoreoperaterecord(props.row)">{{$t('other.a2558')}}</el-button></div>
                                    <div class="btn"><el-button style="min-width:150px" size="mini" type="primary" @click="bindItem(props.row)">{{$t('other.a2892')}}</el-button></div>
                                    
							    </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>

      </div>   

     
   
      
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import utils from '../../../utils/utils'
import api from '../../../api/api'
import userStoreItemsApi from '../../../api/moudles/userStoreItems'
import QrcodeDialog from '../../../components/dialog/qrcodeDialog.vue'
import dialogPlugin from '@/pages/stockProduct/component/diaload'
import jsonp from '../../../api/jsonp';
import mygoods from '../../../api/moudles/mygoods';
import neworderApi from '../../../api/moudles/newOrders'
import distributionApi from '../../../api/moudles/distribution'
import md5 from 'js-md5'
export default {
data(){
return{
    stores:JSON.parse(localStorage.getItem('userInfo')).stores,
    shopIdInfo:JSON.parse(localStorage.getItem('shopIdInfo')),
    storesOptions:[],
    agentList:[],
    fixGrossProfitRate:null,
    productModel:null,
    value4:false,
    diaGrossmargin:false,
    groupItem:null,
    productCode:false,
    showErrorDeleteItem:false,
    agentDialog:false,
    listErrorOptions:[],
    multipleSelection:[],
    itemCoding:null,
    warehouseId:null,
    isComponent:null,
    openDiaconfigPackage:false,
    onlineItems:{},
    tableList:[],
    additionItem: null,
    tableCount:0,
    type:null,
    barCode:null,
    productType:true,
    onlineItems:null,
    isShow:false,
    isEditGoods:false,
    dataParams:{
        addition:false,
        component:true,
        cusCode:null,
        offset:15,
        page:0,
        sellerId:null,
        storeId:null,
        userId:JSON.parse(localStorage.getItem('userInfo')).userId
    },
    offset: 15,
    page: 0,
    massPrice:null,
    dialogTableVisibleTwo:false,
    showDistributionPrice:false,
    showProduct:false,
    currentPage4: 1,
    packageInfo:{},
    additionParents:[],
    agentList:[],
    textDest:null,
    disPrice:false,
    openDialog:false,
    imageUrl:'',
    handleParam:null,
    costDia:false,
    packageList:[],
    options: [
        {
          label: this.$t('other.a1341'),
          value: true,
        },
        {
          label: this.$t('other.a1342'),
          value: false,
        },
      ],
    changePicObj:{},
    dataParams:{
        component: true,
        cusCode: "",
        offset: 50,
        page: 0,
        sellerId: JSON.parse(localStorage.getItem('userInfo')).userId,
        storeId: null,
        userId: JSON.parse(localStorage.getItem('userInfo')).userId,
    },
    ruleForm:{
        groupName:'',
        categoryId:null,
        itemSku:'',
        storeItems:[]
    },
    token:{
        token:JSON.parse(localStorage.getItem('userInfo')).token
    },
    multipleSelection:[],
    checked:false,
    instockdia:false,
    maincusCode:null,
    vipLevel:JSON.parse(localStorage.getItem('userInfo')).vipLevel,
    updatPic:false
}
},

components: {
    QrcodeDialog,
    dialogPlugin
    
    
},

 computed: {
    ...mapState({
      userName: (state) => state.shopaccess.userInfo.userName,
      userId: (state) => state.shopaccess.userInfo.userId,
            isSuper: (state) => state.shopaccess.userInfo.isSuper,
            distributorLevel: (state) => state.shopaccess.userInfo.distributorLevel,
     
    }),
    
},

watch:{
    checked(){
        if(this.checked){
            this.ruleForm.storeItems.forEach(p => {
                this.$refs.multipleTable.toggleRowSelection(p)
            })
        }else{
            this.$refs.multipleTable.clearSelection();
        }    
    },
    productCode(){
        if(!this.productCode){
            this.barCode=null
        }
    },
    updatPic(){
        if(!this.updatPic){
            this.imageUrl=''
        }
    },
   
},


created(){
    this.init()
},
destroyed(){
    // utils.cleanStorageData()
},
methods:{
...mapActions('userStoreItems', [
    'getInstockoperaterecore',
    'deleStoreItems',
    'sellerUpdateStoreItemDetail',//更新采购价
    'sellerUpdateStoreItem',//更新产品基本信息
    'updateGroup'
]),

getVipPirice(item) {
            let price = null
            if (this.isSuper) {
                price = item.children&&item.children.length>0?(item.children[0].price):0
            } else {
                if (this.distributorLevel == 0) {
                    price = item.children&&item.children.length>0?(item.children[0].vipPrice ? item.children[0].vipPrice : item.children[0].price):0
                } else if (this.distributorLevel == 1) {
                    price = item.children&&item.children.length>0?(item.children[0].superVipPrice ? item.children[0].superVipPrice : item.children[0].price):0
                }
            }
            return price
        },

bindItem(item){
     console.log(item)
     mygoods
     .getBindItems({
         cusCode:item.cusCode
     })
     .then(res => {
     if(res.code === 200 ){
     console.log('desc',res.data)
     this.onlineItems={
         sku:item,
         list:res.data,
         storeId:this.ruleForm.storeId
     }
     this.showProduct=true
     }else{
     this.$message.warning(res.msg)
     }
     })
 },

turnOn(){
    this.value4=!this.value4
    if(this.value4){
        this.$confirm(this.$t('other.a2893'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            this.value4=!this.value4
        })
    }else{

        this.diaGrossmargin=true
        // this.$confirm('开启固定毛利率后，系统会根据绑定的线上产品的最低折后人民币价格自动计算每个sku的分销供货价，确认开启吗？', this.$t("other.a142"), {
        // confirmButtonText: this.$t('other.a235'),
        // cancelButtonText: this.$t('other.a146'),
        // type: 'warning'
        // }).then(() => {
        //     this.value4=!this.value4
        // })
    }
},

updataDistribute(){
    console.log(this.ruleForm)
    if(this.ruleForm.storeItems){
        let list=this.ruleForm.storeItems.map(p => {
            return p.cusCode
        })

        if(list){
            let arr=[]
            list.forEach(p => {
                mygoods
                .getBindItems({
                    cusCode:p
                })
                .then(res => {
                if(res.code === 200 ){
                console.log('desc',res.data)
                if(res.data){
                    res.data.forEach(p => {
                        let shopIdInfo=this.shopIdInfo.find(item => item.shopId == p.shopId)
                        p.country=this.ruleForm.country
                        p.rmbList=[]
                        if(shopIdInfo){
                            p.rmbList=res.data.map(item => utils.interestRateConversion(shopIdInfo.country,item.price))
                            if(p.rmbList){
                                 p.minRmb=Math.min(...p.rmbList)
                            }else{
                                p.minRmb=this.$t("other.a354")
                            }
                        }
                        p.priceList=res.data.map(item => item.price)
                    })
                    arr.push(...res.data)

                    if(arr.length > 0){
                        console.log('arr',arr)
                    }else{
                        this.$message.warning(this.$t('other.a2894'))
                    }
                }

                }else{
                this.$message.warning(res.msg)
                }
                })

            })

            setTimeout(() => {
                let variations= this.ruleForm.storeItems.map((i,index) => {
                            let ttp=arr.find(item => item.cusCode == i.cusCode)
                            
                            return {
                                stock:i.storeNum > 0 ? i.storeNum : 0,
                                shopIdInfo:ttp ? ttp.shopIdInfo : null,
                                price:i.price,
                                image:ttp ? ttp.image : null,
                                imageId:ttp ? ttp.imageId : null,
                                variationSku:i.skuName,
                                name:i.skuName,
                                country:this.ruleForm.country,
                                priceList:ttp ? Math.min(...ttp.priceList)  : 0,
                                minRmb:ttp ? ttp.minRmb  : 0,
                                tierIndex:[index],
                                cusCode:i.cusCode,
                                packageHeight:i.packageHeight,
                                packageLength:i.packageLength,
                                packageWidth:i.packageWidth,
                                weight:i.weight,
                                fixGrossProfitRate:0,
                                wholesalePrice:i.wholesalePrice
                            }
                        })

                        console.log('variations',variations)
                       
                        

                        localStorage.setItem('onlineItem',JSON.stringify({
                            arr:arr,
                            variations:variations,
                        }))
                        
                        this.$router.push({
                            path:'/stockProduct/template',
                            query:{
                                groupId:this.$route.query.groupId,
                                type:this.$route.query.type,
                                storeId:this.ruleForm.storeId

                            }
                        })
                        console.log('arr',arr)
            }, 5000);

            
        }

    
        console.log('list',list)

    }else{
        this.$message.warning(this.$t('other.a2895'))
    }
},

openUrl(num){

    console.log(this.ruleForm)
    if(num == 0){//以自定义分销供货价上价
        this.textDest=this.$t('other.a2564')
        this.disPrice=true
    }else if(num == 1){
        this.textDest=this.$t('other.a2565')
        this.disPrice=false
    }
    let flags=false
    let  obj = this.ruleForm.categoryData
    console.log('jfkf',obj)
    if(obj){
        for(let i in obj){
            console.log(obj[i])
            if(!obj[i]){
                flags=true
            }
        }

    }else{
        flags=true

    }
    if(flags && !this.ruleForm.productId){
        this.$router.push({
            path:'/editor',
            query:{
                groupId:this.$route.query.groupId,
                storeId:this.ruleForm.storeId
            }
        })

        return
    }

    if(this.ruleForm.productId ){
        this.showDistributionPrice=true
        this.massPrice= this.disPrice ? this.ruleForm.storeItems[0].price : this.ruleForm.fixGrossProfitRate
        return 
    }


    this.showDistributionPrice=true
    this.massPrice=this.ruleForm.storeItems[0].price



    console.log(this.ruleForm)

    
},

kvjhfm(item){
    this.openDialog=true
    this.handleParam=this.ruleForm
    
},

createItemNotProduct(data){
    console.log(this.type)
    console.log(data)
    console.log('data',data)
    let params={
        addition:this.type == 2 ? true : false,
        address:null,
        component:true,
        cost:0,
        cusCode:0,
        encoding:null,
        groupId:this.handleParam ? this.handleParam.groupId : null,
        groupName:this.handleParam ? this.handleParam.groupName : null,
        image:data.imageUrl,
        itemSku:null,
        packageHeight:Number(data.height),
        packageLength:Number(data.long),
        packageWidth:Number(data.width),
        weigth:Number(data.weigth),
        shopId:this.handleParam ? this.handleParam.shopId : null,
        shopee:true,
        skuName:data.name,
        storeId:this.handleParam ? this.handleParam.storeId : null,
        userId:this.userId,
        variationName:data.variationName,
    }

    console.log('params',params)
    userStoreItemsApi   
    .addStoreItemNotProduct(params)
    .then(res => {
        if(res.code === 200) {
            this.$message.success(this.$t('other.a2566'))
            if(res.data.successItem){
                this.getDataByGroupId()
            }

        }else{
            this.$message.warning(res.msg)
        }
    })
},


changerPrice(){
    this.massPrice=Number(this.massPrice)
    let ttp = /^[0-9]+.?[0-9]*$/.test(this.massPrice)

    console.log(ttp,this.massPrice)
    if(!ttp){
        this.massPrice=null
        this.$message.warning(this.$t('other.a2567'))
        return
    }

    if(this.massPrice < 0){
        this.$message.warning(this.$t('other.a2567'))
    }else{
        if(this.disPrice){
            this.ruleForm.storeItems.forEach(p => {
                p.price=this.massPrice
            })
            this.ruleForm.fixGrossProfitRate=null

        }else{
            this.ruleForm.fixGrossProfitRate=this.massPrice
        }
    }
   
},

OffShelf(){
    console.log(this.ruleForm)
    this.ruleForm.putAway=false
    this.ruleForm.storeItems.forEach(p => {
        p.putAway=false
    })
    distributionApi
    .soldOutWholePsku(this.ruleForm)
    .then(res => {
    if(res.code === 200 ){
    console.log('desc',res.data)
    this.$message.success(this.$t('other.a2896'))
    }else{
    this.$message.warning(res.msg)
    }
    })
},
//异步计算产品的毛利
getStoreItemPrice(){
    return new Promise((resolve) => {
        let obj={
            cusCode:null,
            price:null,
        }
        this.ruleForm.storeItems.forEach(p => {
            if(!obj.price){
                obj.cusCode=p.cusCode
                obj.price=p.price
            }
            if(p.price > obj.price){
                obj.cusCode=p.cusCode
                obj.price=p.price
            }
        })

        mygoods
        .getBindItems({
            cusCode:obj.cusCode
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        let  price=[]
        if(res.data){
            res.data.forEach(p => {
                price.push(p.price)
            })
            let num=Math.min(...price)
            let rate=utils.interestRateConversion('TH',num)
            console.log('num',utils.interestRateConversion('TH',num),num)

            resolve(rate)
        }

        
       
        }else{
        this.$message.warning(res.msg)
        }
        })
    
        console.log('groupidlist',this.ruleForm.storeItems,obj)
    
    })
},


distribution(){
    if(!this.disPrice && this.massPrice < 0.05){
        console.log(this.massPrice)
        this.$confirm(this.$t('other.a2568'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a955'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {})

        return
            
        
        
    }
    console.log(this.ruleForm)
    this.showDistributionPrice=false
    this.ruleForm.putAway=false
    let isPrice=false
    this.ruleForm.putAway=true
    this.ruleForm.storeItems.forEach(p => {
        p.putAway=true
        p.price=Number(p.price)
        if(p.price <= 0){
            isPrice=true
        }
    })
    if(isPrice){
        this.$message.warning(this.$t('other.a2569'))
        this.showDistributionPrice=false
        this.ruleForm.putAway=false
        return 
    }

    this
    .getStoreItemPrice()
    .then(res => {
        console.log('res',res)
        let  list =this.ruleForm.storeItems.map(p => {
            return p.price
        })
        
        let maxPrice=Math.max(...list)
        //线上销售最低的零售价
        let lower=Number(res-maxPrice)
        console.log('list',maxPrice,lower)
        let  iinv=lower/maxPrice
        console.log('iinv',iinv)
     
    //     //如果仓库产品绑定了模版
    // if(this.ruleForm.productId){
    //     this.ruleForm.putAway=true
    //     this.ruleForm.storeItems.forEach(p => {
    //         p.putAway=true
    //     })

    //     console.log('ruleForm',this.ruleForm)
    //     distributionApi
    //     .putAwayToDistribution(this.ruleForm)
    //     .then(res => {
    //     if(res.code === 200 ){
    //     console.log('desc',res.data)
    //     this.$message.success(this.$t('other.a2503'))
    //     this.ruleForm.storeItems.forEach(i => {
    //         i.synchrony=true
    //         this.updataSync(i)
    //     })

    //     this.showDistributionPrice=false
    //     }else{
    //     this.$message.warning(res.msg)
    //     }
    //     })
    //     return 
    // }

    let url=null
    // 判断产品是否有itemId,shopId
    if(!this.ruleForm.productId && this.ruleForm.country){
        url=utils.getUrlByItemIDandCountry(this.ruleForm.country,this.ruleForm.categoryData.itemId,this.ruleForm.categoryData.shopId)
        let matchId="itemid=" +this.ruleForm.categoryData.itemId+ '&' + "shopid=" + this.ruleForm.categoryData.shopId
        let if_match_="55b03-" + md5.hex("55b03" + md5.hex(matchId) + "55b03")
        let host=url.slice(0,url.indexOf("?")+1)
        console.log('host',host)

        api
        .scrapedProdcutItem({
            ifMatchIn:if_match_,
            origin:host,
            url:url
        })
        .then(res => {
        if(!res.data){
            this.$message.warning(this.$t('other.a2570'))
            this.ruleForm.putAway=false
            return
        }
        res.item=res.data
        console.log('desc',res)
        let obj={
            attributes:[],
            productShops:[],
            categoryId:0,
            modelId:null,
            name: null,
            images:[],
            status:'NORMAL',
            description:null,
            packageLength:'',
            packageWidth:'',
            packageHeight:'',
            country:'ROOT',
            weight:'',
            price:null,
            hasVariation:false,
            variations:[],
            tiers:[],
            logistics:[],
            userId:null
        }

        if(this.ruleForm.storeItems){
            obj.packageLength=this.ruleForm.storeItems[0].packageLength
            obj.packageWidth=this.ruleForm.storeItems[0].packageWidth
            obj.packageHeight=this.ruleForm.storeItems[0].packageHeight
            obj.weight=this.ruleForm.storeItems[0].weight
        }
        
        obj.description=res.item.description
        obj.name=res.item.name
        obj.sourceUrl=host+matchId
        obj.categoryId=res.item.categories[res.item.categories.length-1].catid
        if(res.item.attributes){
            res.item.attributes.forEach((p,index) => {
                obj.attributes.push({
                    attributeId:p.id,
                    attributeName:p.name,
                    attributeValue:p.value,
                    isMandatory:false
                })
            })


            let obj1 = {};
            let res1 = [];
            obj.attributes.forEach(k => {
                if(!obj1[k.attributeId]){
                    res1.push(k)
                    obj1[k.attributeId]=true
                }
            })

            obj.attributes=res1


        }else{
            res.item.attributes=null
        }

        res.item.images.forEach((p,index) => {
            obj.images.push({
                image:utils.getImageUrl(this.ruleForm.country,p),
                positions:index
            })
        })
        let variations=[];
        res.item.tier_variations.forEach((p,index) => {
            if(p.images){

                p.images=p.images.map(k => {
                    return utils.getImageUrl(this.ruleForm.country,k)
                })
            }
            obj.tiers.push({
                images:p.images,
                name:p.name,
                optionArray:p.options,
                
            })
        })

      
        this.ruleForm.storeItems.forEach((i,index) => {
            variations.push({
                stock:i.storeNum > 0 ? i.storeNum : 0,
                price:i.price,
                variationSku:i.skuName,
                name:i.skuName,
                tierIndex:[index]
            })
        })
        obj.tiers[0].optionArray=[]
        this.ruleForm.storeItems.forEach(p => {
            obj.tiers[0].optionArray.push(p.skuName) 
        })

        obj.variations=variations;
        obj.userId=this.userId
        console.log('obj',obj)

        api
        .updataProduct(obj)
        .then(res => {
            if(res.code === 200){
                api
                .updateProductId({
                groupId:this.ruleForm.groupId,
                storeId:this.ruleForm.storeId,
                productId:res.data.productId,
                userId:this.userId
                })
                .then(res => {
                    if(res.code === 200){
                        this.$message.success(this.$t('other.a2502'))
                        distributionApi
                        .putAwayToDistribution(this.ruleForm)
                        .then(res => {
                        if(res.code === 200 ){
                        console.log('desc',res.data)
                        this.$message.success(this.$t('other.a2503'))
                        this.ruleForm.storeItems.forEach(i => {
                            i.synchrony=true
                            this.updataSync(i)
                        })

                        this.showDistributionPrice=false
                        }else{
                        this.$message.warning(res.msg)
                        }
                        })

                    }else{
                        this.$message.warning(res.msg)
                    }
                })
            }else{
                this.$message.warning(res.msg)
            }
        })
      
        })
    }else{
        distributionApi
        .putAwayToDistribution(this.ruleForm)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a2503'))
        this.ruleForm.storeItems.forEach(i => {
            i.synchrony=true
            this.updataSync(i)
        })

        this.showDistributionPrice=false
        }else{
        this.$message.warning(res.msg)
        }
        })
    }
    })   
},

updataSync(ttp){
      userStoreItemsApi
        .sellerUpdateSynchrony(ttp)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        }else{
        console.log(res.msg)
        }
        })
    },


imgConfirm(){
    console.log(this.changePicObj)
    if(this.changePicObj.type == 0){
        userStoreItemsApi
        .updateStoreParentImage({
            imageUrl:this.changePicObj.image,
            key:this.changePicObj.groupId,
            stringkey:0
        })
        .then(res => {
            if(res.code === 200) {
                this.$message.success(this.$t('other.a2571'))
                this.ruleForm.image=this.changePicObj.image
            }else{
                this.$message.warning(res.msg)
            }
        })
    }

    if(this.changePicObj.type == 1){
        userStoreItemsApi
        .updateStoreItemImage({
            imageUrl:this.changePicObj.image,
            key:this.changePicObj.cusCode,
            stringkey:1
        })
        .then(res => {
            if(res.code === 200) {
                this.$message.success(this.$t('other.a2571'))
                this.ruleForm.storeItems.forEach(p => {
                    if(p.cusCode == this.changePicObj.cusCode){
                        p.image=this.changePicObj.image
                    }
                })
            }else{
                this.$message.warning(res.msg)
            }
        })
    }
},

changePic(item,index){
    this.updatPic=true
    this.changePicObj=JSON.parse(JSON.stringify(item))
    this.changePicObj.type=index

    console.log('changePicObj',this.changePicObj)

    
},

updataIsDistribution(item){
    item.putAway=!item.putAway
    let obj=JSON.parse(JSON.stringify(item))
    if(item.putAway){
        obj.putAway=false
        distributionApi
        .undershelfChildrenSku(obj)
        .then(res => {
        if(res.code === 200 ){
        this.$message.success(this.$t('other.a2572')+ obj.skuName)
        item.putAway=false
        }else{
        this.$message.warning(res.msg)
        }
        })
    }else{
        obj.putAway=true
        distributionApi
        .shelfChildrenSku(obj)
        .then(res => {
        if(res.code === 200 ){
        this.$message.success('sku:'+ obj.skuName+this.$t('other.a2573'))
        item.putAway=true
        }else{
        this.$message.warning(res.msg)
        }
        })
    }
    console.log(item)
},

setIndependent(item){
    userStoreItemsApi
    .updateIndependent({
        independent:item.independent,
        cusCode:item.cusCode,
        userId:this.userId,
        storeId:item.storeId,
    })
    .then(res => {
        if(res.code === 200){
            if(item.independent){
                this.$message.success(this.$t('other.a2574'))
            }else{
                this.$message.warning(this.$t('other.a2575'))
            }
            
        }
    })



},

viewAgent(item){
    console.log('item',item)
    if(item.parents){
        this.agentList=item.parents.map(p => {
            return {
                userId:p.userId,
                userName:p.userName,
                cusCode:p.cusCode,
                unShipped:p.unShipped
            }
        })
        this.agentDialog=true
        console.log('list',list)

    }
},

viewMore(item){
    console.log(item)
    let list=item.parents.map(p => {
        return p.cusCode
    })
    let str=list.join(',')
    console.log(str)
    this.$confirm(this.$t('other.a2576')+str, this.$t("other.a142"), {
    confirmButtonText: this.$t("other.a884"),
    cancelButtonText: this.$t('other.a146'),
    type: 'warning'
    }).then(() => {})

},
viewMoreCopy(item){
    console.log(item)
    let list=item.additions.map(p => {
        return p.cusCode
    })
    let str=list.join(',')
    console.log(str)
    this.$confirm(this.$t('other.a2576')+str, this.$t("other.a142"), {
    confirmButtonText: this.$t("other.a884"),
    cancelButtonText: this.$t('other.a146'),
    type: 'warning'
    }).then(() => {})

},

configPackage(item){
    console.log(item)
    this.openDiaconfigPackage=true
    this.packageList=item.children
    this.packageInfo.storeId=item.storeId
    this.packageInfo.cusCode=item.cusCode
    
},

cancelChangeStock(index,row){
    row.checked_one = false
    this.$set(this.ruleForm.storeItems,index,row)
},

upadataItemPrice(item){
    if(this.ruleForm.fixGrossProfitRate){
        this.$message.warning(this.$t('other.a2897'))
        return
    }

    item.checked02=!item.checked02
},

updataCostAndSupply(item){
    console.log(item)
    item.price=Number(item.price)
    distributionApi
    .modifyPrice(item)
    .then(res => {
        item.checked02=false
    if(res.code === 200 ){
    console.log('desc',res.data)
    this.$message.success(this.$t('other.a2898'))

    this.productModel.variations.forEach(p => {
        if(item.cusCode == p.cusCode){
            p.price=item.price
        }
    })

    console.log('productModel',this.productModel)
    api
    .updataProduct(this.productModel)
    .then(res => {
        if(res.code === 200){
            console.log('新增模版',res.data)
            this.$message.success(this.$t('other.a1411'))   
            
        }else{
            this.$message.warning(res.msg)
        }
    })
    }else{
    this.$message.warning(res.msg)
    }
    })
},

updataItemSku(){
    console.log(this.ruleForm.storeItems)
    this.ruleForm.checked=false
    this.ruleForm.checkedName=false
},

changeStock(index,row){
    console.log(index,row)
    let patten=/^[+-]?(0|([1-9]\d*))(\.\d+)?$/g
   
    if(!patten.test(row.reservedStock)){
        this.$message.warning(this.$t('other.a2578'))
        row.reservedStock=0
        return
    }
    
    console.log(row.reservedStock)
    row.checked_one = false
    this.$set(this.ruleForm.storeItems,index,row)
    
    let params={
        cusCode:row.cusCode,
        storeNum:row.reservedStock,

    }
    api
    .updateReservedStock(params)
    .then(res => {
        if(res.code === 200){
            this.$message.success(this.$t('other.a665'))
            this.getDataByGroupId()
        }else{
            this.$message.warning(res.msg)
        }
    })
    
    
},


insertProduct(){
        this.$router.push({
            path:'/onlineGoods',
            query:{
                storeId:this.ruleForm.storeItems[0].storeId,
                component:this.ruleForm.storeItems[0].component,
                groupId:this.ruleForm.groupId
            }
        })
    },

editResverStock(index,row){
    row.checked_one=true
    this.$set(this.ruleForm.storeItems,index,row)
},
saveClick(index,row){
    row.skuName=row.skuName.trim()
    if(row.skuName.length > 32){
        this.$message.warning(this.$t('other.a2579'))
        return
    }
    console.log(row.skuName.length)
    this.sellerUpdateStoreItem(row).then(res => {
        if(res.code === 200) {
            this.$message.success(this.$t('other.a2580'))
        }else{
            this.$message.warning(res.msg)
        }
    })
    row.skuNameChecked = false
    this.$set(this.ruleForm.storeItems,index,row)
},
saveItems() {
      this.isEditGoods = !this.isEditGoods;
      let arr = this.additionParents.map((p) => {
        return {
          childrenId: this.additionItem.cusCode,
          parentId: p.cusCode,
          rate: p.rate,
        };
      });
      let params = {
        binds: arr,
        parentId: this.additionItem.cusCode,
        userId: this.userId,
      };

      console.log(params);
      // this.updateBindStoreItem(params)
      userStoreItemsApi
      .updateBindStoreItemAddition(params)
      .then(res => {
        if(res.code === 200) {
          this.$message.success(this.$t('other.a2159'))
         this.getDataList.page=0
          this.getStoreItemAndGroup()
          this.isEditGoods=false

        }
      })
    },

  getTableList() {
   this.dataParams.storeId=this.warehouseId
   this.dataParams.component=this.productType
    userStoreItemsApi.
    getStoreItemBystore(this.dataParams).then((res) => {
    if (res.code === 200) {
        console.log("套餐或单品", res.data);
        this.tableList = res.data.items;
        this.tableCount = res.data.count;
    }
    });
},

handleSizeChange(val) {
    console.log(`每页 ${val} 条`);
    this.dataParams.offset = parseInt(`${val}`);
    this.handleCurrentChange();
},

//显示当前第几页
handleCurrentChange(val) {
  
    this.dataParams.page = (parseInt(`${val}`) - 1) * this.dataParams.offset;
    this.getTableList();
    
},
deletGoods(item, index) {
      this.additionParents.splice(index, 1);
    },
addItem() {
    this.multipleSelection.forEach((p) => {
    this.additionParents.push(p);
    });
    this.isShow = false;
    console.log("additionParents", this.additionParents);
},

addGoods() {
      this.isShow = true;
      this.getTableList();
    },
massMoveInSingle(item) {
    this.additionItem = item;
    console.log(item);
    this.additionParents = [];
    this.additionParents = JSON.parse(JSON.stringify(item.additionParents));
    this.dialogTableVisibleTwo = true;
    console.log(this.additionParents);
},
// 移入套餐
updateComponent(item,index){
    console.log(item)
    let params={
        cusCode:item.cusCode,
        component:this.type == 0 ? false : true,
        userId:item.userId,
        storeId:item.storeId
    }

    let text= this.type == 0 ? this.$t('other.a2581') : this.$t('other.a2582')

    this.$confirm(text, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
    }).then(() => {
        
    userStoreItemsApi
    .updataComponent(params)
    .then(res => {
        if(res.code === 200) {
            let dexc= this.type == 0 ? this.$t('other.a2583') : this.$t('other.a2584')
            this.$message.success(dexc)

            this.ruleForm.storeItems.splice(index,1)
        }else{
            this.$message.warning(res.msg)
        }
    })
        
    })
},
removeItem(){
    if(this.multipleSelection){
        this.ruleForm.storeItems.forEach((p,index) => {
            this.multipleSelection.forEach(i => {
                if(p.cusCode == i.cusCode){
                    this.ruleForm.storeItems.splice(index,1)
                }
            })
        })
    }
},

massMoveIn(){
        let arr=[]
        this.multipleSelection.forEach((i,index) => {
           
                arr.push({
                    cusCode:i.cusCode,
                    component:false,
                    userId:i.userId,
                    storeId:i.storeId
                }) 	

                
            
        })
        let text=this.$t('other.a1059') + arr.length + this.$t('other.a2585')
        this.$confirm(text, this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
        }).then(() => {
            let total=0
            console.log(arr)
            arr.forEach(p => {
                userStoreItemsApi
                .updataComponent(p)
                .then(res => {
                    console.log(res)
                    if(res.code === 200) {
                        total +=1
                        if(total == arr.length){
                            this.$message.success(this.$t('other.a2586'))
                            this.removeItem()
                        }
                        console.log('total',total)
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
            })
        })
    },
massDeletd(){
            let arr=[]
            let num =0
            this.multipleSelection.forEach(p => {
               
                    arr.push({
                        cusCode:p.cusCode,
                        userId:this.userId,
                        storeId:p.storeId
                    })

                
            })

            

        console.log(arr)
        let desc=this.$t('other.a2587') + arr.length + this.$t('other.a2588')
        this.$confirm(desc, this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {
                 this.listErrorOptions=[]
                userStoreItemsApi
                .massDeleteStoreItem(arr)
                .then(res => {
                    if(res.code === 200){
                       
                        res.data.forEach(p => {
                            if(p.code == 0){
                            
                            }else{
                               
                                this.listErrorOptions.push({
                                    cusCode:p.cusCode,
                                    desc:p.msg,
                                    storeItem:p.storeItem
                                })
                                this.showErrorDeleteItem=true
                                console.log('删除失败的库存产品',this.listErrorOptions)
                                
                            }
                        })

                        if(!this.listErrorOptions.length){
                            this.$message.success(this.$t('other.a565'))
                            this.removeItem()
                        }
                    
                    }
                })
            
            })
        },

saveClickvariationName(index,row){
    row.variationName=row.variationName.trim()
    if(row.variationName.length > 32){
        this.$message.warning(this.$t('other.a2579'))
        return
    }
    console.log(row.variationName.length)
    this.sellerUpdateStoreItem(row).then(res => {
        if(res.code === 200) {
            this.$message.success(this.$t('other.a2580'))
        }else{
            this.$message.warning(res.msg)
        }
    })
    row.nameChecked = false
    this.$set(this.ruleForm.storeItems,index,row)
},

saveCost(index,row){
    let patten=/^[+-]?(0|([1-9]\d*))(\.\d+)?$/g
   
    if(!patten.test(row.cost)){
        this.$message.warning(this.$t('other.a2578'))
        row.cost=0
        return
    }
    
    console.log(row.cost)
    this.sellerUpdateStoreItemDetail(row).then(res => {
        if(res.code === 200) {
            this.$message.success(this.$t('other.a2589'))
        }else{
            this.$message.warning(res.msg)
        }
    })
    row.costChecked = false
    this.$set(this.ruleForm.storeItems,index,row)
},

editClick(index,row){
    console.log(index,row)
    row.skuNameChecked = true
    this.$set(this.ruleForm.storeItems,index,row)
},
editvaritionNmae(index,row){
    console.log(index,row)
    row.nameChecked = true
    this.$set(this.ruleForm.storeItems,index,row)
},
editcost(index,row){
    console.log(index,row)
    row.costChecked = true
    this.$set(this.ruleForm.storeItems,index,row)
},

handleAvatarSuccess(res, file) {
console.log(res,file)
this.imageUrl = URL.createObjectURL(file.raw);
this.changePicObj.image=res.data

console.log('imageUrl',res.data)
},
beforeAvatarUpload(file) {
const isJPG = file.type === 'image/jpeg';
const isLt2M = file.size / 1024 / 1024 < 10;

if (!isJPG) {
    this.$message.error(this.$t('other.a2592'));
}
if (!isLt2M) {
    this.$message.error(this.$t("other.a333"));
}
return isJPG && isLt2M;
},

submitCoding(){
    console.log(this.barCode)
    if(!this.barCode){
        this.$message.warning(this.$t('other.a2593'))
        return
    }

   
    let obj=JSON.parse(JSON.stringify(this.itemCoding))
    obj.encoding=this.barCode.trim()
    obj.userId=this.userId

    userStoreItemsApi
    .updateEncoding(obj)
    .then(res => {
        if(res.code == 200) {
            this.$message.success(this.$t('other.a2594'))
            this.productCode=false
            this.itemCoding.encoding=JSON.parse(JSON.stringify(this.barCode))
            this.barCode=''
        }else{
            this.$message.warning(res.msg)
        }	
    })
},

changeLockStock(item){
    console.log(item)
    let param={
        autoReserved:item.autoReserved,
        userId:this.userId,
        cusCode:item.cusCode,
        storeId:item.storeId
    }
    item.autoReserved=!item.autoReserved
    if(!item.autoReserved){
            this.$confirm(this.$t('other.a2595'), this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {
                item.autoReserved=true
                param.autoReserved=true
                console.log(param)
                api
                .updateAutoReserved(param)
                .then(res => {
                    if(res.code === 200) {
                        this.$message.success(this.$t('other.a2596'))
                        this.getDataByGroupId()
                    }
                })
            })

    }else{
        this.$confirm(this.$t('other.a2597'), this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {
                item.autoReserved=false
                param.autoReserved=false
                console.log(param)

                api
                .updateAutoReserved(param)
                .then(res => {
                    if(res.code === 200) {
                        this.$message.warning(this.$t('other.a2598'))
                        this.getDataByGroupId()
                    }
                })
            })
    }


},

updateShopeeItem(item){
    item.synchrony = !item.synchrony
    if(!item.synchrony){
        let text=this.$t('other.a2599')
        this.$confirm(text, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a763'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            let ttp=JSON.parse(JSON.stringify(item))
            ttp.synchrony=true
            userStoreItemsApi
            .sellerUpdateSynchrony(ttp)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a2600'))
            item.synchrony=true
            }else{
            this.$message.warning(res.msg)
            }
            })
            
        })
    }else{
        let text=this.$t('other.a2601')
        this.$confirm(text, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a5'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            let ttp=JSON.parse(JSON.stringify(item))
            ttp.synchrony=false
            userStoreItemsApi
            .sellerUpdateSynchrony(ttp)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a2602'))
            item.synchrony=false
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    }
   
  
},

 handleSelectionChange(val) {
    this.multipleSelection = val;
    console.log('multipleSelection',this.multipleSelection)
 },




 init(){
     if(this.$route.query.groupId){
         this.type=this.$route.query.type
         this.getDataByGroupId()
     }
  
  
 },

 getDataByGroupId(){
     api
     .getStoreItemByGroupId({
         groupId:this.$route.query.groupId
     })
     .then(res => {
     if(res.code === 200 ){
     let type=Number(this.$route.query.type )
     console.log('oriderData',res.data)
     this.groupItem=res.data

     api
    .getProductByproductId({
        productId:res.data.productId
    }).then(res => {
        if(res.code == 200){
            console.log('product',res.data)
            this.productModel=res.data

            console.log(type)
     
     let list=[]
     console.log('desc',res.data)
     if(this.groupItem.fixGrossProfitRate){
         this.value4 =true
     }
     this.warehouseId=res.data.storeId
     this.groupItem.checked=false
     this.groupItem.checkedName=false
     this.groupItem.storeItems.forEach((p,index) => {
        console.log(p)
         p.reservedStockCopy=0
		 p.reservedStockTotal=0
         p.assibleUnshiped=0
         p.checked=false
         p.checked02=false
         p.checked_one=false
         p.skuNameChecked=false
         p.costChecked=false
         p.skuChecked=false
         p.fixGrossProfitRate=res.data.fixGrossProfitRate
         p.agentOrderQty=0
         p.agentAuditedStock=0
         p.price=this.getVipPirice(p)
         p.storeNum=p.storeNum
        //  p.storeNum=p.children&&p.children.length>0?p.children[0].storeNum:0
         p.packageHeight=p.children&&p.children.length>0?p.children[0].packageHeight:0
         p.packageLength=p.children&&p.children.length>0?p.children[0].packageLength:0
         p.packageWidth=p.children&&p.children.length>0?p.children[0].packageWidth:0
         p.weight=p.children&&p.children.length>0?p.children[0].weight:0

         if(p.parents !== null){
            if(p.parents.length){
                p.parents.forEach(j => {
                    p.reservedStockCopy +=j.rate * j.reservedStock
                    p.assibleUnshiped+=j.rate*j.unShipped
                    p.agentOrderQty+=j.unShipped
                    p.agentAuditedStock+=j.auditedStock

                })
                
            }
        }
        p.reservedStockTotal=p.reservedStockCopy + p.reservedStock
        if(type == 0 && p.component){
             list.push(p)
        }

        if(type == 1 && !p.component){
             list.push(p)
        }

        if(type == 2  && p.addition){
             list.push(p)
        }

        list.push(p)
     })

     
     this.groupItem.storeItems=list
     this.ruleForm=this.groupItem
     console.log('ruleForm',this.ruleForm)
     console.log('list',list)
        }
    })
     
     
     }else{
     this.$message.warning(res.msg)
     }
     })
 },

 goBack(){

     this.$router.push('/hasAgent')
 },

 bindItem(item){
     console.log(item)
     mygoods
     .getBindItems({
         cusCode:item.cusCode
     })
     .then(res => {
     if(res.code === 200 ){
     console.log('desc',res.data)
     this.onlineItems={
         sku:item,
         list:res.data,
         storeId:this.ruleForm.storeId
     }
     this.showProduct=true
     }else{
     this.$message.warning(res.msg)
     }
     })
 },

 viewstoreoperaterecord(item){
    this.instockdia=true
    this.maincusCode=item.cusCode
    let params={
        cusCode:item.cusCode,
        end:utils.CurdateAddoneday(utils.getRecentDays(0)),
        start:utils.getRecentDays(-7),
        offset:50,
        page:0,
        userId:this.userId
    }
    console.log(params)
    this.getInstockoperaterecore(params)
},

deleStoreItem(item,index) {
    this.$confirm(this.$t('other.a2157'), this.$t("other.a142"), {
    confirmButtonText: this.$t('other.a145'),
    cancelButtonText: this.$t('other.a146'),
    type: 'warning'
    }).then(() => {
    let param={
        cusCode:item.cusCode,
        userId:this.userId,
        storeId:item.storeId
    }

    this.deleStoreItems(param).then(res => {
        if(res.code == 200){
            if(res.data.code == 0){
                this.$message.success(res.data.msg)
                this.ruleForm.storeItems.splice(index,1)
            }else{
                this.$message.warning(this.$t('other.a2603')+ res.data.msg)
            }
        }
        
    })
    
})
    
},

 








}
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";
/deep/ .el-dropdown-menu__item{
        font-size: 22px;
        line-height: 45px;
}

.avatar-uploader .el-upload {
border: 1px dashed #d9d9d9;
border-radius: 6px;
cursor: pointer;
position: relative;
overflow: hidden;
}
.avatar-uploader .el-upload:hover {
border-color: #409EFF;
}
.avatar-uploader-icon {
font-size: 28px;
color: #8c939d;
width: 178px;
height: 178px;
line-height: 178px;
text-align: center;

border: 1px solid #000;
border-radius: 5px;
}


.avatar {
width: 178px;
height: 178px;
display: block;
}

.upload__tip{
    font-size:20px;
}

.stockProduct_box{
    background-color: rgba(226, 222, 222, 0.5);
    min-height: 100vh;


  
    

    

    .el-icon-edit{
        cursor: pointer;
        color: #409EFF;
        font-size: 18px;
        margin-left:10px ;
    }

  .kvhkfn{
      color: #409EFF;
      cursor: pointer;
      width: 150px;
      text-align: center;
  }  


  .header_tip{
      background: #fff ;
     
      padding: 6px 0;

      .ivmfjn{
          display: flex;
          align-items: center;
          padding-left:15px
      }

      
  }

  .menu{
          margin-right: 20px;
      }



  .basic_info{
       
        background-color: #fff;
        padding: 0 16px;
        margin: 15px 10px;
        border-radius: 5px;


        .skuDesc{
            font-size: 18px;
            font-weight: bold;
            margin: 20px 10px;
        }

        .itemskuImg{
            width: 150px;
            height: 150px;
            border: 1px solid #eee;
            border-radius: 3px;
            overflow: hidden;

            

            img{
                width: 100%;
            }
        }

        .el-icon-edit-outline{
            font-size: 17px;
            margin-left: 15px;
            color: #409EFF;
            cursor: pointer;
        }

        .lknf{
             font-size: 17px;
            margin-left: 15px;
            color: #409EFF;
            cursor: pointer;
        }

        .btn{
            margin: 3px 0;
            
            
        }
        .pic_box{
            width: 80px;
            height: 80px;
            border: 1px solid #eee;
            overflow: hidden;
            border-radius: 5px;
        }
        .title{
            height: 40px;
            line-height: 40px;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: .02em!important;
            font-family: Roboto,sans-serif!important;
            border-bottom: 1px solid #eee;
            display: flex;
            align-items: center;
        }

        .basic_detail{
            padding: 15px 0;
            
        }
     
    }

 


    

    .check_desc{
        @include flex-between();
        padding-right: 20px;

     
    }
    .check_Top{
        position: fixed;
        z-index: 99;
        top: 50px;
        width: calc(100% - 205px);
        background-color: #fff;
        border-bottom: 1px solid #eee;
      

    }

   
  
}

</style>